import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

// Mesmo padrão visual de FeedbackBadges/BlockedIpStatusBadge (bolinha + texto).
// critical/error reaproveitam a cor de erro já usada nos badges de status do admin;
// warning reaproveita o âmbar de "Em análise"/"Problema"; info e debug ficam neutros.
const LEVEL_CONFIG = {
  critical: { label: 'Crítico', bg: '#FFEBEE', border: '#FFCDD2', dot: '#E53935', text: '#C62828' },
  error: { label: 'Erro', bg: '#FFEBEE', border: '#FFCDD2', dot: '#E53935', text: '#C62828' },
  warning: { label: 'Aviso', bg: '#FFF3E0', border: '#FFE0B2', dot: '#FB8C00', text: '#E65100' },
  info: { label: 'Info', bg: '#F5F5F5', border: '#E0E0E0', dot: '#9E9E9E', text: '#616161' },
  debug: { label: 'Debug', bg: '#FAFAFA', border: '#EEEEEE', dot: '#BDBDBD', text: '#9E9E9E' },
};

/**
 * LogLevelChip - Indicador de nível de severidade de uma linha de log (Admin Geral > Logs)
 * @param {Object} props
 * @param {string} props.level - 'debug'|'info'|'warning'|'error'|'critical'
 */
function LogLevelChip({ level }) {
  const cfg = LEVEL_CONFIG[level] || { label: level || '—', bg: '#F5F5F5', border: '#E0E0E0', dot: '#9E9E9E', text: '#616161' };

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.6,
        px: 1.25,
        py: 0.4,
        borderRadius: '20px',
        backgroundColor: cfg.bg,
        border: `1px solid ${cfg.border}`,
        width: 'fit-content',
      }}
    >
      <Box sx={{ width: 6, height: 6, borderRadius: '50%', backgroundColor: cfg.dot, flexShrink: 0 }} />
      <Typography
        variant="caption"
        sx={{ fontWeight: 500, fontSize: '0.75rem', lineHeight: 1, color: cfg.text, whiteSpace: 'nowrap' }}
      >
        {cfg.label}
      </Typography>
    </Box>
  );
}

export default LogLevelChip;
